<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Roles'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'RoleSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'role',
        editEntityScreen: 'Admin - Edit/View Role',
        fields: [
          { header: 'Name', prop: 'name', hideByDefault: false },
          { header: 'Code', prop: 'code', hideByDefault: false },
          { header: 'Description', prop: 'description', hideByDefault: true }
        ]
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// RoleSearchResults.vue?2602a430